var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_308",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29258",
    "data-name": "Group 29258",
    transform: "translate(286 11099)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27963",
    "data-name": "Group 27963",
    transform: "translate(-277 -11093)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28370",
    "data-name": "Group 28370",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Ellipse_308)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_308-2",
    "data-name": "Ellipse 308",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "url(#radial-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_14_",
    "data-name": "svgexport-17 (14)",
    transform: "translate(-266.119 -11082.407)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50064",
    "data-name": "Path 50064",
    d: "M3,96.5l-.269.273L0,99.97l.687.476,4.369-2.523Zm0,0",
    transform: "translate(0 -90.127)",
    fill: "#23292e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50065",
    "data-name": "Path 50065",
    d: "M4.048,101.46l-1.907,1.163-1.454,1.69L0,103.838l2.734-3.2Zm0,0",
    transform: "translate(0 -93.994)",
    fill: "#2e373d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50066",
    "data-name": "Path 50066",
    d: "M364.98,151.344a.729.729,0,0,1-.7-.537l-4.62-16.9a.728.728,0,1,1,1.405-.384l4.62,16.9a.728.728,0,0,1-.511.895A.717.717,0,0,1,364.98,151.344Zm0,0",
    transform: "translate(-335.88 -124.201)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50067",
    "data-name": "Path 50067",
    d: "M38.862,96.3a2.667,2.667,0,0,0-2.853-.17l-1.955,1.111c-1,.457-1.637,1.7-1.637,3.51,0,3.114,1.893,6.731,4.228,8.079a2.679,2.679,0,0,0,2.827.187l2.07-1.172c.944-.489,1.547-1.709,1.547-3.466C43.09,101.263,41.2,97.646,38.862,96.3Zm0,0",
    transform: "translate(-30.277 -89.464)",
    fill: "#23292e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50068",
    "data-name": "Path 50068",
    d: "M40.875,123.366c0,3.114-1.893,4.545-4.229,3.2s-4.228-4.966-4.228-8.079,1.893-4.545,4.228-3.2S40.875,120.252,40.875,123.366Zm0,0",
    transform: "translate(-30.277 -107.198)",
    fill: "#2e373d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50069",
    "data-name": "Path 50069",
    d: "M62.169,155.737c0,1.92-1.168,2.8-2.608,1.971a6.246,6.246,0,0,1-2.608-4.983c0-1.92,1.168-2.8,2.608-1.971A6.246,6.246,0,0,1,62.169,155.737Zm0,0",
    transform: "translate(-53.192 -140.506)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50070",
    "data-name": "Path 50070",
    d: "M91.925,187.115l-8.137-4.7a1.56,1.56,0,0,0-1.52-.022.914.914,0,0,0-.748.9,2.48,2.48,0,0,0,1.238,2.147l9.167,5.3Zm0,0",
    transform: "translate(-76.136 -170.175)",
    fill: "#23292e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50071",
    "data-name": "Path 50071",
    d: "M152.223,155.047v2.613a1.543,1.543,0,0,0,.771,1.336l2.871,1.658a2.572,2.572,0,0,1,1.214,2.185V164.2a2.353,2.353,0,0,0,1.177,2.038l2.33,1.345a.892.892,0,0,0,.9,0l4.823-2.776c.021-.011.043-.023.063-.036h0a.89.89,0,0,0,.42-.76,7.4,7.4,0,0,1,.408-2.421l.806-2.329Zm0,0",
    transform: "translate(-142.17 -144.807)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50072",
    "data-name": "Path 50072",
    d: "M89.832,167.751l-3.642-2.1v1.913a1.543,1.543,0,0,0,.771,1.336l2.871,1.658Zm3.605,5.38-10.543-6.095a.916.916,0,0,0-1.374.793,2.48,2.48,0,0,0,1.239,2.147l10.678,6.173Zm0,0",
    transform: "translate(-76.136 -154.708)",
    fill: "#525e65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50073",
    "data-name": "Path 50073",
    d: "M34.5,3.956l-.7-1.215a3.825,3.825,0,0,0-1.4-1.4L30.383.175a1.29,1.29,0,0,0-1.417.078L24.3,2.9a1.29,1.29,0,0,0-.759,1.182A3.385,3.385,0,0,0,25.233,7.01l8.02,4.63,6.033-4.833Zm0,0",
    transform: "translate(-21.985 0)",
    fill: "#627681"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50074",
    "data-name": "Path 50074",
    d: "M34.391,48.863,29.61,46.011l-.7-1.215a3.825,3.825,0,0,0-1.4-1.4L25.489,42.23a1.3,1.3,0,0,0-1.95,1.126,3.385,3.385,0,0,0,1.693,2.932l8.02,4.631Zm0,0",
    transform: "translate(-21.984 -39.277)",
    fill: "#2e373d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50075",
    "data-name": "Path 50075",
    d: "M115.457,62.688l4.893-2.778,4.782,2.852-4.894,2.778Zm0,0",
    transform: "translate(-107.832 -55.953)",
    fill: "#525e65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50076",
    "data-name": "Path 50076",
    d: "M181.85,93.657a5.348,5.348,0,0,0-5.4-.028l-4.678,2.714c-.06.032-.12.064-.179.1a1.987,1.987,0,0,0-.994,1.721v.254l9.713,5.608,4.856-2.813V99.458a6.723,6.723,0,0,0-3.324-5.8Zm0,0",
    transform: "translate(-159.338 -86.777)",
    fill: "#e33400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50077",
    "data-name": "Path 50077",
    d: "M170.6,138.192l9.713,5.608v-1.755a6.723,6.723,0,0,0-3.324-5.8,5.347,5.347,0,0,0-5.4-.028,1.988,1.988,0,0,0-.994,1.721Zm0,0",
    transform: "translate(-159.338 -126.551)",
    fill: "#872e02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50078",
    "data-name": "Path 50078",
    d: "M207.371,197.492l7.285,4.206-.807,2.329a7.4,7.4,0,0,0-.407,2.421.9.9,0,0,1-1.35.78l-2.33-1.345a2.354,2.354,0,0,1-1.177-2.038V202.48a2.572,2.572,0,0,0-1.214-2.184Zm0,0",
    transform: "translate(-193.676 -184.449)",
    fill: "#82a5b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50079",
    "data-name": "Path 50079",
    d: "M348.109,307.416a2.667,2.667,0,0,0-2.853-.17l-1.955,1.111c-1,.457-1.637,1.7-1.637,3.51,0,3.114,1.893,6.731,4.228,8.079a2.679,2.679,0,0,0,2.827.187l2.07-1.172c.945-.489,1.547-1.709,1.547-3.466C352.338,312.381,350.445,308.764,348.109,307.416Zm0,0",
    transform: "translate(-319.1 -286.64)",
    fill: "#23292e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50080",
    "data-name": "Path 50080",
    d: "M338.2,289.844a2.99,2.99,0,0,0-3.351-.122l-2.561,1.479c-1.07.559-1.751,1.946-1.751,3.939a11.59,11.59,0,0,0,1.052,4.609l.291-.142a1.432,1.432,0,0,0,.75-1.672,6.525,6.525,0,0,1-.25-1.73c0-2.185,1.329-3.189,2.967-2.243a4.423,4.423,0,0,1,.953.761,1.2,1.2,0,0,0,1.777-.088l.155-.186,1.779-1.035a1.218,1.218,0,0,0,.919-.439l.155-.186A8.831,8.831,0,0,0,338.2,289.844Zm0,0",
    transform: "translate(-308.702 -270.163)",
    fill: "#e33400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50081",
    "data-name": "Path 50081",
    d: "M350.121,334.484c0,3.114-1.893,4.545-4.228,3.2s-4.229-4.965-4.229-8.079,1.893-4.545,4.229-3.2S350.121,331.37,350.121,334.484Zm0,0",
    transform: "translate(-319.099 -304.374)",
    fill: "#2e373d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50082",
    "data-name": "Path 50082",
    d: "M371.419,366.854c0,1.92-1.168,2.8-2.608,1.972a6.246,6.246,0,0,1-2.608-4.983c0-1.92,1.168-2.8,2.608-1.971a6.246,6.246,0,0,1,2.608,4.983Zm0,0",
    transform: "translate(-342.018 -337.68)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50083",
    "data-name": "Path 50083",
    d: "M390.872,396.426c0,.83-.5,1.212-1.128.852a2.7,2.7,0,0,1-1.128-2.155c0-.83.5-1.212,1.128-.852A2.7,2.7,0,0,1,390.872,396.426Zm0,0",
    transform: "translate(-362.951 -368.106)",
    fill: "#627681"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50084",
    "data-name": "Path 50084",
    d: "M332.375,319.665c0-2.185,1.329-3.189,2.967-2.243a4.422,4.422,0,0,1,.953.761,1.2,1.2,0,0,0,1.777-.088l.154-.186a8.826,8.826,0,0,0-2.884-2.945c-2.657-1.534-4.811.094-4.811,3.637a11.59,11.59,0,0,0,1.052,4.609l.291-.142a1.432,1.432,0,0,0,.75-1.672,6.525,6.525,0,0,1-.25-1.73Zm0,0",
    transform: "translate(-308.702 -293.623)",
    fill: "#872e02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50085",
    "data-name": "Path 50085",
    d: "M329.256,172.977a.729.729,0,0,1-.7-.537l-4.62-16.9a.729.729,0,1,1,1.405-.384l4.62,16.9a.729.729,0,0,1-.7.921Zm0,0",
    transform: "translate(-302.515 -144.405)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50086",
    "data-name": "Path 50086",
    d: "M362.519,23.632a.729.729,0,0,1-.365-1.36l1.873-1.081a.728.728,0,1,1,.728,1.262l-1.872,1.081A.725.725,0,0,1,362.519,23.632Zm0,0",
    transform: "translate(-337.896 -19.701)",
    fill: "#2e373d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50087",
    "data-name": "Path 50087",
    d: "M375.115,44.688h-2.421a.393.393,0,1,1,0-.786h2.421a.393.393,0,1,1,0,.786Zm0,0",
    transform: "translate(-347.712 -41.003)",
    fill: "#2e373d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50088",
    "data-name": "Path 50088",
    d: "M238.62,47.081a3.83,3.83,0,0,1-2.74-1.152l-2.263-2.312a.728.728,0,0,1,1.041-1.019l2.263,2.312a2.376,2.376,0,0,0,2.887.4l2.317-1.338a1.393,1.393,0,0,0,.667-1.5l-.888-4.12a.728.728,0,0,1,1.424-.307l.888,4.12a2.846,2.846,0,0,1-1.363,3.073l-2.317,1.338A3.823,3.823,0,0,1,238.62,47.081Zm0,0",
    transform: "translate(-217.994 -34.987)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50089",
    "data-name": "Path 50089",
    d: "M197.667,114.778a.729.729,0,0,1-.365-1.359l2.409-1.391a.728.728,0,0,1,.728,1.262l-2.408,1.39A.724.724,0,0,1,197.667,114.778Zm0,0",
    transform: "translate(-183.932 -104.538)",
    fill: "#2e373d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50090",
    "data-name": "Path 50090",
    d: "M323.209,120.073l-1.25-.722a3.824,3.824,0,0,0-3.824,0,3.272,3.272,0,0,0,0,5.667l2.243,1.321a1.41,1.41,0,0,0,1.527-.082,5.378,5.378,0,0,0,2.246-4.291C324.151,120.962,323.779,120.288,323.209,120.073Zm0,0",
    transform: "translate(-295.596 -110.991)",
    fill: "#82a5b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50091",
    "data-name": "Path 50091",
    d: "M368.843,138.375a5.378,5.378,0,0,1-2.246,4.291c-1.24.716-2.246-.044-2.246-1.7a5.378,5.378,0,0,1,2.246-4.291c1.24-.716,2.246.044,2.246,1.7Zm0,0",
    transform: "translate(-340.289 -127.399)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50092",
    "data-name": "Path 50092",
    d: "M253.09,152.181a3.812,3.812,0,0,1-1.592,3.042c-.879.508-1.592-.031-1.592-1.2a3.814,3.814,0,0,1,1.592-3.042C252.377,150.47,253.09,151.009,253.09,152.181Zm-11.977,7.564a3.3,3.3,0,0,0,1.377,2.63c.76.439,1.377-.027,1.377-1.041a3.3,3.3,0,0,0-1.377-2.631C241.729,158.265,241.113,158.731,241.113,159.745Zm0,0",
    transform: "translate(-225.189 -140.828)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50093",
    "data-name": "Path 50093",
    d: "M233.51,124.718a.383.383,0,0,1-.09-.011.393.393,0,0,1-.293-.472l.628-2.686a.393.393,0,1,1,.766.179l-.629,2.686A.393.393,0,0,1,233.51,124.718Zm0,0",
    transform: "translate(-217.72 -113.238)",
    fill: "#2e373d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBike);
export default __webpack_public_path__ + "static/media/Bike.d0e644761fde0194e33abadfc6f34230.svg";
export { ForwardRef as ReactComponent };